import React from "react";
import { useStats } from "../hooks/useApi";
import { formatNumber, formatRelativeDate } from "../utils";
import { Skeleton } from "./ui/Skeleton";

const StatsPanel: React.FC = () => {
  const { data: stats, isLoading, error } = useStats();

  if (isLoading) {
    return <Skeleton className="h-5 w-2/3 sm:w-1/2 mb-12" />;
  }

  if (error || !stats) return null;

  const total = formatNumber(stats.totalTags);
  const last = stats.lastRelease;

  return (
    <p className="mb-12 text-sm text-muted-foreground">
      <span className="text-foreground font-medium tabular-nums">{total}</span>{" "}
      {stats.totalTags === 1 ? "versão publicada" : "versões publicadas"}
      {last && (
        <>
          {" · última "}
          <span className="font-mono text-foreground">{last.tagName}</span>
          {", "}
          {formatRelativeDate(last.date)}
        </>
      )}
    </p>
  );
};

export default StatsPanel;
